import { AddIcon } from "../../../assets/icons";
import { ButtonProps, IconButton } from "@altimateai/lego";
import classes from "../details/styles.module.scss";
import { createPortal } from "react-dom";

type Props = ButtonProps & {
  target: HTMLElement;
};
const HotspotButton = ({ target, ...rest }: Props) => {
  return createPortal(
    <IconButton
      className={classes.hotspotButton}
      title="Click to start conversation"
      {...rest}
    >
      <AddIcon />
    </IconButton>,
    target,
  );
};

export default HotspotButton;
